export const ACCOUNT_PERMISSION_ENUM = {
  ACCOUNT_GET: 'shop.account:get'
}

export const isAccountGetAllowed = (permissionIsEnabledFn) => {
  return permissionIsEnabledFn(ACCOUNT_PERMISSION_ENUM.ACCOUNT_GET)
}
